var mod = function (n, m) {
    return ((n % m) + m) % m;
};
export default mod;
//# sourceMappingURL=mod.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/mod.js
// module id = 510
// module chunks = 3